/* eslint-disable consistent-return */
import pubsub from 'pubsub-js';

class Events {
	constructor() {
		this.SHOW_LANDING_PAGE = 'LANDINGPAGE';
		this.SHOW_FILE_TABLE = 'FILETABLE';
		this.FILE_ADDED = 'FILEADDED';
		this.FILE_REMOVED ='FILEREMOVED';
		this.UPLOADING = 'UPLOADING';
		this.UPLOADING_DONE = 'UPLOADINGDONE';
		this.FILES_DELETED = 'FILES_DELETED';
	}
	ShowFileTable = () => {
		pubsub.publish(this.SHOW_FILE_TABLE);
	}

	OnUploading = (func, unsubscribe) => {
		this._On(func, unsubscribe, this.UPLOADING);
	}

	RaiseUploading = () => {
		pubsub.publish(this.UPLOADING);
	}

	OnUploadingDone = (func, unsubscribe) => {
		this._On(func, unsubscribe, this.UPLOADING_DONE);
	}

	RaiseUploadingDone = () => {
		pubsub.publish(this.UPLOADING_DONE);
	}

	OnFileAdded = (func, unsubscribe) => {
		this._On(func, unsubscribe, this.FILE_ADDED);
	}

	RaiseFileAdded = () => {
		pubsub.publish(this.FILE_ADDED);
	}

	OnFileRemoved = (func, unsubscribe) => {
		this._On(func, unsubscribe, this.FILE_REMOVED);
	}

	RaiseFileRemoved = () => {
		pubsub.publish(this.FILE_REMOVED);
	}

	OnFilesDeleted = (func, unsubscribe) => {
		this._On(func, unsubscribe, this.FILES_DELETED);
	}

	RaiseFilesDeleted = () => {
		pubsub.publish(this.FILES_DELETED);
	}

	SubscribeToShowFileTable = func => {
		pubsub.subscribe(this.SHOW_FILE_TABLE, func);
	}

	_On = (func, unsubscribe, TOPIC) => {
		if (unsubscribe) {
			pubsub.unsubscribe(func);
			return;
		}
		pubsub.subscribe(TOPIC, func);
	}
}
const instance = new Events();
Object.freeze(instance);
export default instance;




// WEBPACK FOOTER //
// ./src/Events.js